import { useMemo } from 'react';

export type ExtraPageActionVisibilityConfig = {
  /** When false, Excel Export is omitted from the extra-actions menu. Default true. */
  excelExport?: boolean;
  /** When false, Bulk Actions is omitted from the extra-actions menu. Default true. */
  bulkActions?: boolean;
  /** When false, PDF Export is omitted from the extra-actions menu. Default true. */
  pdfExport?: boolean;
};

export type ExtraPageActionVisibility = {
  excelExport: boolean;
  bulkActions: boolean;
  pdfExport: boolean;
};

/**
 * Resolves which layout extra-actions (overflow menu) should be included.
 * Omitted config keys default to visible so callers only override what they gate.
 */
export const useExtraPageActionVisibility = (
  config: ExtraPageActionVisibilityConfig = {}
): ExtraPageActionVisibility => {
  const { excelExport = true, bulkActions = true, pdfExport = true } = config;

  return useMemo(
    () => ({
      excelExport,
      bulkActions,
      pdfExport,
    }),
    [excelExport, bulkActions, pdfExport]
  );
};
